import EntityState from './EntityState';

export { Props } from './EntityState';
export default EntityState;
